/**
 * Every <img> that renders an attachment URL must set this, thumbnails included. Chrome's
 * image cache does not vary on the CORS mode: a thumbnail loaded without `crossOrigin`
 * sends no `Origin` header, so the response cached against that URL carries no
 * `Access-Control-Allow-Origin`. The ticket drawer's image — which has to stay
 * canvas-exportable so it can be rotated — then reuses that entry, fails the CORS check,
 * and reports a perfectly good image as broken.
 */
export const ATTACHMENT_IMAGE_CROSS_ORIGIN = 'anonymous';
